import request from 'utils/request'

export const getMCAXS441InitRequest = () =>
  request({
    url: '/MCAXS441/init',
    method: 'post',
  })
